import React from "react";
import Modal from "react-responsive-modal";
import "./styles.css";
import { Button, Card, Flex } from "discover.medical.react-component-library";

export const ConfirmationModalWindow = ({
  isOpenedModal,
  handleCancelButtonClick,
  handleContinueButtonClick,
  message,
}) => (
  <Modal
    open={isOpenedModal}
    onClose={handleCancelButtonClick}
    center={true}
    closeOnEsc={false}
    blockScroll={false}
    closeOnOverlayClick={true}
    showCloseIcon={true}
    classNames={{
      modal: "confirmation-window",
      overlay: "confirmation-window__overlay",
    }}
  >
    <Card padding="md">
      <p className="confirmation-window__description">{message}</p>
      <Flex
        className="confirmation-window__button-wrapper"
        container
        justify={{ content: "center" }}
      >
        <Button
          onClick={handleContinueButtonClick}
          className="confirmation-window__button"
          marginRight="md"
        >
          Turn Off Auto-Renew
        </Button>
        {handleCancelButtonClick && (
          <Button
            onClick={handleCancelButtonClick}
            className="confirmation-window__button"
          >
            Cancel
          </Button>
        )}
      </Flex>
    </Card>
  </Modal>
);
